import { useAutoBetTourStore } from '@/stores/auto-bet-tour-store';
import { useShallow } from 'zustand/shallow';

export const useAutoBetTour = () =>
	useAutoBetTourStore(
		useShallow((state) => ({
			isActive: state.isActive,
			stage: state.stage,
			start: state.start,
			setStage: state.setStage,
			stop: state.stop,
		})),
	);
